import { render, staticRenderFns } from "./captcha.vue?vue&type=template&id=18d8f9ce&scoped=true"
import script from "./captcha.vue?vue&type=script&lang=js"
export * from "./captcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8f9ce",
  null
  
)

export default component.exports